import React from "react";

const LandingPage = () => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        padding: "40px",
        backgroundColor: "#f8f9fa",
      }}
    >
      <h1 style={{ color: "#1d3557", fontSize: "2.5rem" }}>
        🚀 Become a Full-Stack Developer with Next.js & FastAPI!
      </h1>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <img src="/nextjs.svg" alt="Next.js" width="80" />
        <img src="/react-js.svg" alt="React.js" width="80" />
        <img src="/python.svg" alt="Python" width="80" />
        <img src="/mongodb.svg" alt="MongoDB" width="80" />
        <img src="/fastapi.png" alt="fast api" width="130" />
      </div>
      <h2 style={{ color: "#e63946", fontSize: "1.8rem" }}>
        🔥 Limited-Time Offer: Enroll Now for Just 20,000 PKR (Original Price:
        40,000 PKR) 🔥
      </h2>
      <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
        ⏳ Only 20 Spots Left – Secure Yours Today!
      </p>

      <h3 style={{ color: "#457b9d" }}>
        📌 Master Python, JavaScript, Next.js & FastAPI
      </h3>
      <p
        style={{
          fontSize: "1.1rem",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        Build real-world full-stack applications! This course takes you from
        absolute basics to advanced development, helping you launch
        high-performance web apps.
      </p>

      <h3 style={{ color: "#2a9d8f" }}>📞 Contact Us Now to Enroll:</h3>
      <a
        href="https://wa.me/923261891899"
        target="blank"
        style={{
          display: "inline-block",
          backgroundColor: "#28a745",

          color: "#fff",
          padding: "15px 30px",
          fontSize: "1.2rem",
          fontWeight: "bold",
          textDecoration: "none",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          transition: "0.3s ease",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#c70039")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#ff5733")}
      >
        📲 Enroll Now on WhatsApp
      </a>

      <h3 style={{ color: "#264653", marginTop: "30px" }}>
        🎓 Live & Interactive Weekend Classes on Zoom!
      </h3>
      <p
        style={{
          fontSize: "1.1rem",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        This course is designed for working professionals, students, and
        freelancers who want to learn full-stack development without disrupting
        their schedule.
      </p>

      <h3 style={{ color: "#e76f51", marginTop: "3rem" }}>
        📊 Why Learn Full-Stack Development?
      </h3>
      <p
        style={{
          fontSize: "1.1rem",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        💼 The demand for Full-Stack Developers is booming! According to
        LinkedIn, full-stack developers are among the top 5 most in-demand tech
        roles globally.
      </p>
      <p
        style={{
          fontSize: "1.1rem",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        💰 Average Salary: A skilled full-stack developer earns $100,000+ per
        year in international markets. Even in Pakistan, developers with Next.js
        & FastAPI expertise make over 300,000 PKR/month!
      </p>
      <p
        style={{
          fontSize: "1.1rem",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        🌎 Work Remotely: 90% of startups and companies now hire remote
        developers, allowing you to work for international clients from the
        comfort of your home!
      </p>

      <h3 style={{ color: "#1d3557", marginTop: "3rem" }}>
        📅 Class Schedule:
      </h3>
      <ul
        style={{
          listStyleType: "none",
          padding: 0,
          fontSize: "1.1rem",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        <li>✅ Live Zoom Classes – Fully interactive sessions with Q&A.</li>
        <li>✅ Only on Weekends – 3-hour classes on Saturday & Sunday.</li>
        <li>✅ Duration: 10-12 Weeks (Comprehensive step-by-step learning).</li>
      </ul>

      <h2 style={{ color: "#e63946", marginTop: "30px" }}>
        🔥 Limited-Time Discount – Save 50%
      </h2>
      <p style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
        💰 Enroll now for just 20,000 PKR (Original Price: 40,000 PKR)! <br />⏳
        Only 20 spots left – Secure yours before they’re gone!
      </p>

      <a
        href="https://wa.me/923261891899"
        target="blank"
        style={{
          display: "inline-block",
          backgroundColor: "#28a745",
          color: "#fff",
          padding: "15px 30px",
          fontSize: "1.2rem",
          fontWeight: "bold",
          textDecoration: "none",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          transition: "0.3s ease",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
      >
        📲 Contact on WhatsApp to Enroll Now!
      </a>

      <h3 style={{ color: "#1d3557", marginTop: "3rem" }}>📊 FAQ</h3>
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          textAlign: "left",
          fontSize: "1.1rem",
          lineHeight: "1.6",
        }}
      >
        <p>
          <strong>❓ Can beginners take this course?</strong>
          <br />
          Absolutely yes. Even if you haven't written a single line of code, you
          can start with this course and become a full-stack developer in just
          2.5-3 months. But you will definitely have to practice.
        </p>

        <p>
          <strong>❓ What do I need to start this course?</strong>
          <br />
          You jut need a good laptop and an internet connection.
        </p>

        <p>
          <strong>
            ❓ Will I be able to apply for jobs after this course?
          </strong>
          <br />
          Yes, that is the reason you will be taking this course. After this,
          your will be able to apply for industry jobs as you will have
          real-world projects to showcase your expertise.
        </p>

        <p>
          <strong>❓ Who will be teaching this course?</strong>
          <br />
          This course will be taught by industry experts having professional
          full-stack experience.
        </p>

        <p>
          <strong>
            ❓ Will I be taught the basics of Python and JavaScript?
          </strong>
          <br />
          Yes, the first class will guide you through the setup of the
          development environment, and the next class will cover the basics of
          programming, teaching you everything from scratch.
        </p>

        <p>
          <strong>
            ❓ Why should I take this course instead of just learning from
            YouTube?
          </strong>
          <br />
          YouTube has a vast array of unstructured content, making it difficult
          to focus on what is really important. If you want a structured
          approach to actually becoming a full-stack developer and getting a job
          that respects your skills, then this course is for you. In addition,
          YouTube often leads to "tutorial hell" where you keep watching videos
          without applying what you learn.
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
